// FAQ list (fragrance-faq.css): animates each accordion row's height, and fades its answer, on open and close.
// Horizon's CSS-only animation needs interpolate-size, which only Chromium supports, so Safari and Firefox
// would open and close instantly. Rows keep Horizon's <details> markup, keyboard support and open-by-default
// setting; this only replaces the instant toggle, in the same way as Horizon's show-more.js.
(() => {
  if (window.fragranceFaqRows) return;
  window.fragranceFaqRows = true;

  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  /** @type {WeakMap<HTMLDetailsElement, Animation[]>} */
  const running = new WeakMap();

  /** @param {HTMLDetailsElement} details @param {HTMLElement} summary */
  const closedHeight = (details, summary) => {
    const style = getComputedStyle(details);
    return summary.offsetHeight + parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
  };

  document.addEventListener('click', (event) => {
    const summary = event.target instanceof Element
      ? event.target.closest('.fragrance-layout--faq accordion-custom > details > summary')
      : null;
    if (!(summary instanceof HTMLElement) || reducedMotion.matches) return;
    const details = /** @type {HTMLDetailsElement} */ (summary.parentElement);
    const content = details.querySelector(':scope > .details-content');
    if (!(content instanceof HTMLElement)) return;
    event.preventDefault();

    // A click during a close reopens the row from wherever the animation has reached.
    const opening = !details.open || details.classList.contains('is-closing');
    const startHeight = details.getBoundingClientRect().height;
    const startOpacity = getComputedStyle(content).opacity;
    running.get(details)?.forEach((animation) => animation.cancel());

    // `is-closing` shows the closed icon and row spacing while the open row shrinks.
    details.classList.toggle('is-closing', !opening);
    details.open = true;
    const endHeight = opening ? details.getBoundingClientRect().height : closedHeight(details, summary);
    // Duration and easing come from fragrance-faq.css, which also times the icon to match.
    const style = getComputedStyle(details);
    const timing = {
      duration: parseFloat(style.getPropertyValue('--faq-toggle-duration')) * 1000 || 400,
      easing: style.getPropertyValue('--faq-toggle-easing').trim() || 'ease',
    };

    details.style.overflow = 'hidden';
    const height = details.animate({ height: [`${startHeight}px`, `${endHeight}px`] }, timing);
    const fade = content.animate({ opacity: [startOpacity, opening ? '1' : '0'] }, timing);
    running.set(details, [height, fade]);

    height.onfinish = () => {
      if (!opening) details.open = false;
      details.classList.remove('is-closing');
      details.style.overflow = '';
      running.delete(details);
    };
  });
})();
